import { useEffect, useState } from "react";
import pickupImage from "./static/slide_02.webp";
import pickupMobileImage from "./static/slide_02-mobile.webp";
import truckImage from "./static/main_carousel.webp";
import truckMobileImage from "./static/main_carousel-mobile.webp";
import { Link } from "react-router-dom";
import "./hero-carousel.css";

const items = [
  {
    key: "1",
    image: pickupImage,
    mobileImage: pickupMobileImage,
    className: "carousel-slide carousel-slide-2",
    title: <>Пикапы для города,<br />бездорожья и бизнеса</>,
    points: ["новые автомобили в наличии", "цены с НДС, возможен лизинг"],
  },
  {
    key: "2",
    image: truckImage,
    mobileImage: truckMobileImage,
    className: "carousel-slide carousel-slide-1",
    title: <>Европейские седельные тягачи и&nbsp;полуприцепы для грузоперевозок</>,
    points: ["новые и с пробегом", "в наличии и под заказ"],
  },
];

function HeroCarousel({ level = 1 }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [loadedImages, setLoadedImages] = useState({});
  const [pendingIndex, setPendingIndex] = useState(null);
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);
  const paused = hovered || focused;
  const [reducedMotion, setReducedMotion] = useState(() =>
    window.matchMedia("(prefers-reduced-motion: reduce)").matches,
  );

  useEffect(() => {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    const changed = event => setReducedMotion(event.matches);
    query.addEventListener("change", changed);
    return () => query.removeEventListener("change", changed);
  }, []);

  useEffect(() => {
    if (!loadedImages[0] || paused || reducedMotion) return undefined;
    const timer = setInterval(() => {
      const next = (activeIndex + 1) % items.length;
      if (!document.hidden && loadedImages[next]) setActiveIndex(next);
    }, 3500);
    return () => clearInterval(timer);
  }, [activeIndex, loadedImages, paused, reducedMotion]);

  const showSlide = index => {
    if (loadedImages[index]) {
      setPendingIndex(null);
      setActiveIndex(index);
    }
    else setPendingIndex(index);
  };
  const imageLoaded = index => {
    setLoadedImages(previous => ({ ...previous, [index]: true }));
    if (pendingIndex === index) {
      setActiveIndex(index);
      setPendingIndex(null);
    }
  };

  return (
    <section
      className="main-carousel"
      aria-label="Предложения General Trucks"
      aria-roledescription="карусель"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocusCapture={() => setFocused(true)}
      onBlurCapture={event => {
        if (!event.currentTarget.contains(event.relatedTarget)) setFocused(false);
      }}
    >
      {items.map((item, index) => {
        const active = index === activeIndex;
        const Heading = index === 0 && level === 1 ? "h1" : "h2";
        return (
          <div key={item.key} className={`hero-carousel-item ${active ? "hero-slide-active" : ""}`} aria-hidden={!active}>
            <div className={item.className}>
              {(index === 0 || loadedImages[0] || pendingIndex === index) && (
                <picture className="hero-carousel-image">
                  <source media="(max-width: 650px)" srcSet={item.mobileImage} />
                  <img src={item.image} width="1920" height="660" alt=""
                    loading={index === 0 ? "eager" : "lazy"}
                    fetchpriority={index === 0 ? "high" : "low"}
                    onLoad={() => imageLoaded(index)} onError={() => imageLoaded(index)} />
                </picture>
              )}
              <div className="content">
                <div className="carousel__info hero-carousel-copy">
                  <Heading>{item.title}</Heading>
                  {item.points.map(point => <span key={point}>{point}</span>)}
                  <Link className="carousel__button" to="/catalogue" tabIndex={active ? 0 : -1}>Подобрать технику</Link>
                </div>
              </div>
            </div>
          </div>
        );
      })}
      <button className="hero-arrow hero-prev" aria-label="Предыдущий слайд" onClick={() => showSlide((activeIndex + items.length - 1) % items.length)} />
      <button className="hero-arrow hero-next" aria-label="Следующий слайд" onClick={() => showSlide((activeIndex + 1) % items.length)} />
      <div className="hero-dots">
        {items.map((item, index) => <button key={item.key} aria-label={`Слайд ${index + 1}`} aria-pressed={index === activeIndex} onClick={() => showSlide(index)} />)}
      </div>
    </section>
  );
}

export default HeroCarousel;
